'use client';

import type { OpdsFeed, LibraryConnection } from '@/lib/opds/types';
import { EntryCard } from './EntryCard';

export function NavigationFeed({
  feed,
  library,
}: {
  feed: OpdsFeed;
  library: LibraryConnection;
}) {
  return (
    <div className="nav-grid grid grid-cols-1 gap-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
      {feed.entries.map((entry, i) => (
        <EntryCard
          key={`${entry.id}-${i}`}
          entry={entry}
          library={library}
          isNavigation
        />
      ))}
    </div>
  );
}
